import React from 'react'

import { Jump } from '~/components/elements/Jump'
import { Typography } from '~/components/elements/Typography'

import { type IndicatorWithCustomized } from '../../utils'

export type InPageLinkProps = {
  indicator: IndicatorWithCustomized
  label: string
}

export const InPageLink = ({ indicator, label }: InPageLinkProps) => (
  <Jump hash={indicator}>
    <Typography variant="link1" whiteSpace="preWrap">
      {label}
    </Typography>
  </Jump>
)
